import { LoadingSkeleton } from 'sonata-react-components';

import VisitationMetricTrendsSkeleton from './VisitationMetricTrends/VisitationMetricTrendsSkeleton';

import './components/LineItemComparisonTable/lineItemComparisonTable.scss';
import './aggregatedReportSkeleton.scss';

const LINE_ITEM_COMPARISON_SKELETON_ROW_COUNT = 3;

type Props = {
  isMultiLineItem?: boolean;
};

export default function AggregatedReportSkeleton({ isMultiLineItem = false }: Readonly<Props>) {
  return (
    <div className="aggregatedReportSkeleton">
      <div className="aggregatedReportSkeleton__topRow">
        <div className="aggregatedReportSkeleton__brandStore">
          <div className="aggregatedReportSkeleton__brandStoreContent">
            <div className="aggregatedReportSkeleton__subtitle">
              <LoadingSkeleton height={16} width="60%" />
              <LoadingSkeleton height={14} width="80%" />
            </div>
            <div className="aggregatedReportSkeleton__divider" />
            <div className="aggregatedReportSkeleton__metrics">
              <div className="aggregatedReportSkeleton__metricsMain">
                <LoadingSkeleton height={20} width={130} />
                <LoadingSkeleton height={32} width={110} />
              </div>
              <LoadingSkeleton height={13} width="65%" />
            </div>
          </div>
        </div>

        <div className="aggregatedReportSkeleton__kpi">
          {Array.from({ length: 3 }).map((_, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton — index is stable
            <div className="aggregatedReportSkeleton__kpiCard" key={i}>
              <div className="aggregatedReportSkeleton__kpiCardTop">
                <LoadingSkeleton height={40} width={40} />
                <LoadingSkeleton height={32} width="50%" />
              </div>
              <LoadingSkeleton height={14} width="60%" />
              <LoadingSkeleton height={12} width="75%" />
            </div>
          ))}
        </div>
      </div>

      {isMultiLineItem && (
        <div className="lineItemComparisonTable">
          <div className="lineItemComparisonTable__header">
            <LoadingSkeleton height={16} width={16} />
            <LoadingSkeleton height={20} width={180} />
            <div className="lineItemComparisonTable__headerRight">
              <LoadingSkeleton height={24} width={160} />
              <LoadingSkeleton height={32} width={140} />
              <LoadingSkeleton height={32} width={220} />
            </div>
          </div>
          <div className="lineItemComparisonTable__listColumnsBar">
            <span className="lineItemComparisonTable__colLineItem">
              <LoadingSkeleton height={14} width={80} />
            </span>
            <span className="lineItemComparisonTable__colPois">
              <LoadingSkeleton height={14} width={36} />
            </span>
            <span className="lineItemComparisonTable__colInvestment">
              <LoadingSkeleton height={14} width={70} />
            </span>
            <span className="lineItemComparisonTable__colUplift">
              <LoadingSkeleton height={14} width={50} />
            </span>
            <span className="lineItemComparisonTable__colCpsv">
              <LoadingSkeleton height={14} width={40} />
            </span>
            <span className="lineItemComparisonTable__colRoi">
              <LoadingSkeleton height={14} width={36} />
            </span>
            <span className="lineItemComparisonTable__colNav" />
          </div>
          <div className="lineItemComparisonTable__body">
            {Array.from({ length: LINE_ITEM_COMPARISON_SKELETON_ROW_COUNT }).map((_, i) => (
              <div className="lineItemComparisonTable__row" key={i}>
                <div className="lineItemComparisonTable__lineItemCell">
                  <LoadingSkeleton height={16} width="70%" />
                  <LoadingSkeleton height={13} width="55%" />
                  <LoadingSkeleton height={13} width="45%" />
                </div>
                <span className="lineItemComparisonTable__colPois">
                  <LoadingSkeleton height={16} width={24} />
                </span>
                <span className="lineItemComparisonTable__colInvestment">
                  <LoadingSkeleton height={16} width={70} />
                </span>
                <div className="lineItemComparisonTable__upliftCell">
                  <LoadingSkeleton height={16} width={50} />
                  <LoadingSkeleton height={13} width={70} />
                </div>
                <span className="lineItemComparisonTable__colCpsv">
                  <LoadingSkeleton height={16} width={50} />
                </span>
                <span className="lineItemComparisonTable__colRoi">
                  <LoadingSkeleton height={16} width={50} />
                </span>
                <span className="lineItemComparisonTable__colNav">
                  <LoadingSkeleton height={20} width={20} />
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="aggregatedReportSkeleton__trafficRow">
        <div className="aggregatedReportSkeleton__trafficHeader">
          <LoadingSkeleton height={18} width="30%" />
          <LoadingSkeleton height={24} width={100} />
        </div>
        <LoadingSkeleton height={13} width="50%" />
        <LoadingSkeleton height={28} width="35%" />
        <LoadingSkeleton height={350} width="100%" />
      </div>
      <div className="aggregatedReportSkeleton__visitationRow">
        <VisitationMetricTrendsSkeleton />
      </div>
    </div>
  );
}
